// extracted by mini-css-extract-plugin
export default {"expenses_section_wrapper":"Expenses_expenses_section_wrapper__Xehpv","heading":"Expenses_heading__QSQUF","expenses_chart_wrapper":"Expenses_expenses_chart_wrapper__npPUv"};